import { useCallback } from 'react';
import { useGlobalAppStateStore } from '../../../../../stores/app/GlobalAppStateStore';

export function useDrawerNavigatorOperations() {
  const { setNavigationState } = useGlobalAppStateStore().hooks.useActions();

  const showDrawerNavigator = useCallback(() => {
    setNavigationState({ isDrawerOpen: true });
  }, [setNavigationState]);

  const hideDrawerNavigator = useCallback(() => {
    setNavigationState({ isDrawerOpen: false });
  }, [setNavigationState]);

  return { showDrawerNavigator, hideDrawerNavigator };
}
